import ApiService from './index';
const resourceList = '/api/Systems/GetNews';

const News = {
  getList() {
    return ApiService.get(resourceList);
  },
  get(id) {
    return ApiService.get('/api/Systems/DetailNews?id=' + id);
  },
  getNewsAuctionPaging(params) {
    return ApiService.get('api/Systems/getNewsAuctionPaging', params);
  },
  getNewsPaging(params) {
    return ApiService.get('api/Systems/getNewsPaging', params);
  }
};

export default News;



// WEBPACK FOOTER //
// ./src/common/api/news.js